import React, { FormEvent } from 'react';

import type { ItemSummary } from '@/types/item/ItemSummary';

import { Catalog } from '@/types/Catalog';

import { ReviewPageBody } from './ReviewPageBody';
import { ReviewPageHeader } from './ReviewPageHeader';

type Props = {
    baseUrl: string;
    catalog: Catalog;
    disableSubmit: boolean;
    handleContinueClick: () => void;
    handleNotReceivedItemsClicked: () => void;
    handleNotTalkedToHouseClick: () => void;
    handleReceivedItemsClicked: () => void;
    handleTalkedToHouseClick: () => void;
    items: ItemSummary[];
    note: string;
    noteChange: (event: FormEvent<HTMLTextAreaElement>) => void;
    noteValid: boolean;
    openSendSellerMessageModal: Function;
    ratingChangeAccuracy: (value: number) => void;
    ratingChangeOverall: (value: number) => void;
    ratingChangePayment: (value: number) => void;
    ratingChangeResponsiveness: (value: number) => void;
    ratingChangeShipping: (value: number) => void;
    receivedItems: boolean;
    review: string;
    reviewChange: (event: FormEvent<HTMLTextAreaElement>) => void;
    reviewError: boolean;
    reviewHeadlineChange: (event: FormEvent<HTMLInputElement>) => void;
    reviewHeadlineError: boolean;
    reviewSubmitted: boolean;
    reviewValid: boolean;
    selectedContinue: boolean;
    selectedRecievedItems: boolean;
    submitReview: () => void;
    talkedToHouse: boolean;
};

export const ReviewPage = ({
    baseUrl,
    catalog,
    disableSubmit,
    handleContinueClick,
    handleNotReceivedItemsClicked,
    handleNotTalkedToHouseClick,
    handleReceivedItemsClicked,
    handleTalkedToHouseClick,
    items,
    note,
    noteChange,
    noteValid,
    openSendSellerMessageModal,
    ratingChangeAccuracy,
    ratingChangeOverall,
    ratingChangePayment,
    ratingChangeResponsiveness,
    ratingChangeShipping,
    receivedItems,
    review,
    reviewChange,
    reviewError,
    reviewHeadlineChange,
    reviewHeadlineError,
    reviewSubmitted,
    reviewValid,
    selectedContinue,
    selectedRecievedItems,
    submitReview,
    talkedToHouse,
}: Props) => {
    return (
        <div className="mx-auto max-w-[1240px] pr-md pb-lg">
            <ReviewPageHeader
                baseUrl={baseUrl}
                catalog={catalog}
                handleNotReceivedItemsClicked={handleNotReceivedItemsClicked}
                handleReceivedItemsClicked={handleReceivedItemsClicked}
                items={items}
                receivedItems={receivedItems}
                selectedReceivedItems={selectedRecievedItems}
            />
            <ReviewPageBody
                catalog={catalog}
                disableSubmit={disableSubmit}
                handleContinueClick={handleContinueClick}
                handleNotTalkedToHouseClick={handleNotTalkedToHouseClick}
                handleTalkedToHouseClick={handleTalkedToHouseClick}
                note={note}
                noteChange={noteChange}
                noteValid={noteValid}
                openSendSellerMessageModal={openSendSellerMessageModal}
                ratingChangeAccuracy={ratingChangeAccuracy}
                ratingChangeOverall={ratingChangeOverall}
                ratingChangePayment={ratingChangePayment}
                ratingChangeResponsiveness={ratingChangeResponsiveness}
                ratingChangeShipping={ratingChangeShipping}
                receivedItems={receivedItems}
                review={review}
                reviewChange={reviewChange}
                reviewError={reviewError}
                reviewHeadlineChange={reviewHeadlineChange}
                reviewHeadlineError={reviewHeadlineError}
                reviewSubmitted={reviewSubmitted}
                reviewValid={reviewValid}
                selectedContinue={selectedContinue}
                selectedRecievedItems={selectedRecievedItems}
                submitReview={submitReview}
                talkedToHouse={talkedToHouse}
            />
        </div>
    );
};
